import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × RAPHAEL: Harmony, composition, and visual equilibrium
// Balanced composition, harmonic fields, golden hues
export function VasarelyRaphaelMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Perfect circular harmony */}
      <g transform="translate(397 540)">
        {/* Harmonic concentric circles */}
        {Array.from({ length: 18 }).map((_, i) => {
          const r = 30 + i * 16;
          const colors = [brand.amber, brand.aqua, brand.violet];
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={colors[i % 3]}
              strokeWidth="2"
              opacity={0.5 - i * 0.02}
            />
          );
        })}

        {/* Balanced quadrants with optical distortion */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          return (
            <g key={angle}>
              {/* Radial harmonic lines */}
              {Array.from({ length: 8 }).map((_, i) => {
                const len = 60 + i * 25;
                return (
                  <line
                    key={i}
                    x1="0"
                    y1="0"
                    x2={Math.cos(rad) * len}
                    y2={Math.sin(rad) * len}
                    stroke={brand.amber}
                    strokeWidth="1.5"
                    opacity={0.4 - i * 0.04}
                  />
                );
              })}
              
              {/* Equilibrium nodes */}
              <circle
                cx={Math.cos(rad) * 240}
                cy={Math.sin(rad) * 240}
                r="8"
                fill={brand.violet}
                opacity="0.7"
              />
            </g>
          );
        })}

        {/* Golden ratio spiral overlay */}
        {Array.from({ length: 40 }).map((_, i) => {
          const angle = i * 0.5;
          const r = 10 + i * 6;
          const x = Math.cos(angle) * r;
          const y = Math.sin(angle) * r;
          return (
            <circle
              key={i}
              cx={x}
              cy={y}
              r="3"
              fill={brand.aqua}
              opacity={0.6 - i * 0.012}
            />
          );
        })}

        {/* Symmetrical optical grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 12 }).map((_, j) => {
            const x = (i - 5.5) * 35;
            const y = (j - 5.5) * 35;
            const dist = Math.sqrt(x * x + y * y);
            if (dist > 240) return null;
            const distort = Math.sin(dist * 0.05) * 5;
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 8 + distort}
                y={y - 8 - distort}
                width="16"
                height="16"
                fill={brand.white}
                opacity={0.1 + (1 - dist / 240) * 0.15}
              />
            );
          })
        )}

        {/* Perfect symmetry markers */}
        {[-1, 1].map((xDir) =>
          [-1, 1].map((yDir) => (
            <circle
              key={`${xDir}-${yDir}`}
              cx={xDir * 170}
              cy={yDir * 170}
              r="12"
              fill="none"
              stroke={brand.amber}
              strokeWidth="3"
              opacity="0.8"
            />
          ))
        )}
      </g>

      {/* Harmony label */}
      <text x="397" y="100" textAnchor="middle" fontFamily="serif" fontSize="13" fill={brand.amber} opacity="0.6">
        HARMONIA PERFECTA
      </text>
    </g>
  );
}
